import Figure from "~/components/figure"
import Circuit from "~/components/circuit"

export default class Pathways2 extends Component {
  render() {
    return (
      <Surface gridColumn="screen" alignItems="center">
        <Surface
          justifyContent="space-between"
          alignSelf="center"
          flexFlow="row"
        >
          <Circuit
            circuitProps={{
              moduleWidth: "auto",
              firstActiveNeurons: [`mixed4a:222`, `mixed4a:325`],
            }}
            inlineLayerNames
            circuit={[
              {
                name: "mixed4a",
                modules: [
                  {
                    name: "Left",
                    neurons: [222, 325],
                  },
                ],
              },
              {
                name: "mixed4b",
                modules: [
                  {
                    name: "Left",
                    neurons: [429, 384],
                  },
                  {
                    name: "Right",
                    neurons: [443, 431],
                  },
                ],
              },
            ]}
          />

          <Circuit
            circuitProps={{
              moduleWidth: "auto",
              firstActiveNeurons: [`mixed4a:308`, `mixed4a:234`],
            }}
            inlineLayerNames
            circuit={[
              {
                name: "mixed4a",
                modules: [
                  {
                    name: "Right",
                    neurons: [308, 234],
                  },
                ],
              },
              {
                name: "mixed4b",
                modules: [
                  {
                    name: "Left",
                    neurons: [429, 384],
                  },
                  {
                    name: "Right",
                    neurons: [443, 431],
                  },
                ],
              },
            ]}
          />
        </Surface>
      </Surface>
    )
  }
}
